import React, { useEffect, useRef, useState } from 'react';
import MobileMenuOpen from '../svgs/MobileMenuOpen';
import MobileMenuClose from '../svgs/MobileMenuClose';
import ScalamentoWordMark from '../svgs/ScalamentoWordmark';
import settings from '../config/settings';

import { Link, useLocation } from 'react-router-dom';
import { scrollToSection } from '../utils/scrollUtils';
import { useTranslation } from 'react-i18next';
import { loadLanguage } from '../config/i18n';

function NavBarMobile() {
  const { i18n, t } = useTranslation();
  const [activeSection, setActiveSection] = useState('why');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const location = useLocation();

  // Switch language
  const changeLanguage = (lng) => {
    loadLanguage(lng);
  };

  const renderLanguageButton = () => {
    return settings.navBar.languages.map(language => (
      <button
        key={language}
        className={`byrd-xl-l navbar-mobile-button-language ${i18n.language === language ? 'navbar-mobile-button-language-selected' : ''}`} 
        onClick={() => changeLanguage(language)}
      >
        {t(`NavBar.NavItem.Language.${language.charAt(0).toUpperCase() + language.slice(1)}`)}
      </button>
    ));
  };
  
  function renderNavItem() {
    return settings.navBar.navSections.map(section => {
      const isLink = location.pathname === '/privacy' || location.pathname === '/imprint';
      const Element = isLink ? Link : 'a';
      const props = {
        key: section,
        className: `navbar-mobile-item-${section} byrd-xl-l${activeSection === section ? ` highlighted` : ''}`
      };
  
      if (isLink) {
        props.to = `/#${section}`;
      } else {
        props.href = `#${section}`;
        props.onClick = (e) => scrollToSection(e, { mobile: true });
      }
  
      return (
        <Element {...props}>
          {t(`NavBar.NavItem.${section.charAt(0).toUpperCase() + section.slice(1)}`)}
        </Element>
      );
    });
  }


  // Funktion zum Umschalten des Menüs
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, [location, location.hash]);

  // Dieser Hook wird verwendet, um die Fenstergröße zu überwachen und die Fensterbreite zu aktualisieren
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
  
    window.addEventListener('resize', handleResize);
    // Setze die Fenstergröße beim ersten Rendern
    handleResize();
  
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderWriteUsButton() {
    const isLink = location.pathname === '/privacy' || location.pathname === '/imprint';
    const Element = isLink ? Link : 'a';
    const props = {
      className: `navbar-mobile-button-writeus byrd-xl-xb ${activeSection === 'writeus' ? 'navbar-mobile-button-writeus-highlighted' : ''}`,
      'aria-label': t('NavBar.ContactButton')
    };
  
    if (isLink) {
      props.to = "/#writeUs";
    } else {
      props.href = "#writeUs";
      props.onClick = (e) => scrollToSection(e, { mobile: false });
    }
  
    return (
      <Element {...props}>
        {t('NavBar.ContactButton')}
      </Element>
    );
  } 


  // Dieser Hook wird verwendet, um das Scrollverhalten zu überwachen und das Menü zu fixieren
  useEffect(() => {
    const handleScroll = () => { 
      // Scrollspy-Logik hinzufügen
      const sections = settings.navBar.sections;
      let activeSection = '';
  
      sections.forEach(section => {
        const element = document.getElementById(section);
        // Stelle sicher, dass das Element existiert, bevor getBoundingClientRect aufgerufen wird
        if (element) {
          const rect = element.getBoundingClientRect();
  
          // Überprüfen, ob die Sektion teilweise im Viewport ist
          if (rect.bottom > 0 && rect.top < window.innerHeight) {
            activeSection = section;
          }
        }
      });
  
      setActiveSection(activeSection || 'why');
    };
  
    window.addEventListener('scroll', handleScroll);
  
    // Event Listener bereinigen, wenn die Komponente unmountet
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  return (
    <div className="navbar-mobile">
      <Link to="/" className='navbar-mobile-wordmark' onClick={scrollToSection} aria-label={t('NavBar.NavItem.Home')}>
        <ScalamentoWordMark />
      </Link>
      <div className="navbar-mobile-content">
        <div className="navbar-mobile-toggler-wrapper">
          <button className={isMenuOpen ? "navbar-mobile-toggler-close" : "navbar-mobile-toggler-open"} onClick={toggleMenu} aria-label={t(isMenuOpen ? 'NavBar.Toggler.Close' : 'NavBar.Toggler.Open')}>
            {isMenuOpen ? <MobileMenuClose /> : <MobileMenuOpen />}
          </button>
        </div>
        {isMenuOpen && (
        <div className="navbar-mobile-menu active">
          <div className='navbar-mobile-navigation'>
            {renderNavItem()}          
          </div>         
          <div className="navbar-mobile-write-us">
            {renderWriteUsButton()}
          </div>
          <div className="navbar-mobile-language">
            {renderLanguageButton()}
          </div>
        </div>
        )}
      </div>
    </div>
  );
}

export default NavBarMobile;
